// Module
var code = "<p>Choose a data format for the webhook payload. The data format is JSON by default.</p> <p>The Web Form format uses url-encoded data. Just as if a regular HTML Form called the specified endpoint URL.</p> ";
// Exports
module.exports = code;